import React from 'react';
import { string } from 'prop-types';

const Title = ({ title }) =>
  title && (
    <div className="pg-opt pin">
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <h1>{title}</h1>
          </div>
          {/*        
        <div className="col-md-6 col-sm-6">
          <ol className="breadcrumb">
            <li>
              <a href="#">Home</a>
            </li>
            <li>
              <a href="#">Pages</a>
            </li>
            <li className="active">About us</li>
          </ol>
        </div>
        */}
        </div>
      </div>
    </div>
  );

Title.propTypes = { title: string };

Title.defaultProps = { title: '' };

export default Title;
